import { FC, useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Footer } from './components/Footer'
import { HeaderWrapper } from './components/header/HeaderWrapper'
import { PERMISSION_CONSTANTS } from '../../app/core/constants/common/permission-constants';
import { PageDataProvider, useLayout } from './core'
import { DrawerMessenger, RightToolbar } from '../partials'
import { themeModeSwitchHelper, useThemeMode } from '../partials/layout/theme-mode/ThemeModeProvider'
import { MenuComponent } from '../assets/ts/components'
import clsx from 'clsx'
import { WithChildren } from '../helpers'
import { AsideDefault } from './components/aside/AsideDefault'
import { Config } from '@/core/config/config'
import trMessages from "devextreme/localization/messages/tr.json";
import {locale,loadMessages } from "devextreme/localization";
import PermissionWrapper from '@/core/wrappers/permission-wrapper'

const MasterLayout: FC<WithChildren> = ({ children }) => {
  const { mode } = useThemeMode()
  const location = useLocation()
  const jsonObject: string = (localStorage.getItem(Config.VITE_APP_I18N_CONFIG_KEY) || '').toString();
  const language = JSON.parse(jsonObject);
  if (language.selectedLang === 'tr') {
    loadMessages(trMessages);
    locale('tr');
  }
  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])

  useEffect(() => {
    themeModeSwitchHelper(mode)
  }, [mode])

  return (
    <PageDataProvider>
      <div className='page d-flex flex-row flex-column-fluid'>
        <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
          <HeaderWrapper />
          <AsideDefault />
          <Outlet />
          <Footer />
        </div>
      </div>

      {/* begin:: Drawers */}
      {/* <ActivityDrawer /> */}
      <RightToolbar />

      <PermissionWrapper permission={PERMISSION_CONSTANTS.AIR}><DrawerMessenger /></PermissionWrapper>
      {/* end:: Drawers */}

      {/* begin:: Modals */}
      {/* <InviteUsers /> */}
      {/* <UpgradePlan /> */}
      {/* end:: Modals */}
      {/* <ScrollTop /> */}
    </PageDataProvider>
  )
}

export { MasterLayout }
